import GhostContentAPI from '@tryghost/content-api'
import { assertEx } from '@xylabs/sdk-js'

export const GhostApi = new GhostContentAPI({
  key: assertEx(import.meta.env.VITE_GHOST_API_KEY, () => 'Error missing Ghost API Key'),
  url: import.meta.env.VITE_GHOST_API_URL ?? globalThis.location.origin,
  version: 'v3',
})
